// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4bd6da88","item":"_f54480ce"};